import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

interface VersionCheckProps {
  buildTime: string;
  buildVersion: string;
}

export const VersionCheck: React.FC<VersionCheckProps> = ({ buildTime, buildVersion }) => {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile
    const mobileCheck = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    setIsMobile(mobileCheck);

    // Check for new version - only show if we have a stored build time that's different
    const lastBuildTime = localStorage.getItem('lastBuildTime');
    const hasShownUpdate = sessionStorage.getItem('updateShown');
    
    console.log('VersionCheck Debug:', {
      lastBuildTime,
      currentBuildTime: buildTime,
      hasShownUpdate,
      isDifferent: lastBuildTime !== buildTime,
      shouldShow: lastBuildTime && lastBuildTime !== buildTime && !hasShownUpdate && window.location.hostname !== 'localhost'
    });
    
    if (lastBuildTime && lastBuildTime !== buildTime && !hasShownUpdate && window.location.hostname !== 'localhost') {
      console.log('Showing update prompt');
      setShowUpdatePrompt(true);
      // Mark that we've shown the update prompt
      sessionStorage.setItem('updateShown', 'true');
    } else {
      console.log('Hiding update prompt - no update needed');
      setShowUpdatePrompt(false);
    }
  }, [buildTime]);

  const handleUpdate = () => {
    console.log('Update button clicked');
    // Hide the component immediately
    setShowUpdatePrompt(false);
    
    // Clear the update shown flag
    sessionStorage.removeItem('updateShown');
    
    // Force reload with cache busting
    const url = new URL(window.location.href);
    url.searchParams.set('v', buildTime);
    url.searchParams.set('t', Date.now().toString());
    console.log('Reloading with URL:', url.toString());
    window.location.href = url.toString();
  };

  if (!showUpdatePrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 bg-yellow-500 text-white p-4 rounded-lg shadow-lg max-w-sm mx-auto">
      <div className="flex items-center space-x-2">
        <RefreshCw className="w-5 h-5 animate-spin" />
        <div>
          <h3 className="font-semibold">Update Available</h3>
          <p className="text-sm opacity-90">
            {isMobile ? 'New version available. Please refresh to update.' : 'New version available.'}
          </p>
        </div>
      </div>
      <button
        onClick={handleUpdate}
        className="mt-2 w-full bg-white text-yellow-600 px-3 py-1 rounded text-sm font-medium hover:bg-yellow-50 transition-colors"
      >
        Update Now
      </button>
    </div>
  );
}; 